/** an enumeration of supported mobile push services */
export enum MobilePush {
  /** Google Firebase Cloud Messaging (FCM) */
  FCM = 'GCM',
  /** Apple Push Notification Service (APNS) */
  APNS = 'APNS',
  /** Apple Push Notification Service - Development (APNS_SANDBOX) */
  APNS_SANDBOX = 'APNS_SANDBOX',
}
